import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {ApplicationsPanelId} from '../../store/panels/panelStateBase';
import {NonNativeSidePanelFrame} from '../../store/stateless/sidePanelFrameSelectors';
import {LegacyApplicationsProviderContainer} from '../applications/legacyApplicationsProviderContainer';
import {PopupApplicationContainer} from '../applications/popup/popupApplicationContainer';
import {Frame} from '../common/frames/frame';

/*
 * Props.
 */

interface PopupApplicationsProps {
  panelId: ApplicationsPanelId;
  frame: NonNativeSidePanelFrame;
  popupWidth?: number;
  onRequestClose: Handler;
}

/*
 * Component.
 */

export const PopupApplications: FC<PopupApplicationsProps> = (props) => {
  const {panelId, popupWidth, frame, onRequestClose} = props;
  return (
    <Frame
      minWidth="270px"
      width={popupWidth ?? 300}
      height={700}
      shouldForcePopout
      onRequestClose={onRequestClose}
      startHeight={undefined}
    >
      <LegacyApplicationsProviderContainer>
        <PopupApplicationContainer panelId={panelId} frame={frame} onRequestClose={onRequestClose} />
      </LegacyApplicationsProviderContainer>
    </Frame>
  );
};
